import { useState } from 'react';
import styles from '../assets/styles/UserAccess.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';


const Login = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get('status');
  const [isLoading, setIsLoading] = useState(false);

  // ログイン
  const [signupEmail, setSignupEmail] = useState<string>();
  const [signupPwd, setSignupPwd] = useState<string>();

  const handleSignUpSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (signupEmail == undefined || signupEmail.trim() === '') return;
    if (signupPwd == undefined || signupPwd.trim() === '') return;
    try {
      setIsLoading(true);

      const params = new URLSearchParams();
      params.append('username', signupEmail);
      params.append('password', signupPwd);

      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        credentials: 'include',
        body: params,
      });

      if (res.ok) {
        window.location.replace('/board?status=success');
      } else {
        alert(`ログインに失敗しました：${'不明なエラー'}`);
      }
    } catch (error) {
      console.error('ログイン送信エラー:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetPassword = () => {
    window.location.href = '/reset-password';
  };

  const handlePreRegister = () => {
    window.location.href = '/pre-register';
  };

  return (
    <div className={styles.containerWrap}>
      <div className={styles.backgroundGlow}>
        <div className={styles.glowBlue} />
        <div className={styles.glowPink} />
      </div>
      <a href="/" className={styles.backLink}>← トップページへ戻る</a>

      <div className={styles.container}>
        <div className={styles.userAccessContent}>
          <div className={styles.userAccessContentInner}>
            <div className={styles.userAccessFrom}>
              {(status === "loggedout" || status === "need_login") && (
                <div className={styles.paramTxt}>
                  {status === "loggedout"
                    ? "ログアウトしました！"
                    : "ログインしてください"}
                </div>
              )}

              <img src="/images/logo_aibex_line_b.svg" alt="AI-BEX" className={styles.logo} />

              <h1>ログイン</h1>

              <form onSubmit={handleSignUpSubmit}>
                <label>ID(メールアドレス)</label>
                <input
                  type="email"
                  value={signupEmail}
                  onChange={(e) => setSignupEmail(e.target.value)}
                  placeholder="email@example.com"
                  required
                  className={styles.inputTxt}
                />
                <label>パスワード</label>
                <input
                  type="password"
                  value={signupPwd}
                  onChange={(e) => setSignupPwd(e.target.value)}
                  placeholder="passwordを入力"
                  required
                  className={styles.inputTxt}
                />
                <div className={styles.formLinks}>
                  <a onClick={handleResetPassword}>パスワードを忘れた方はこちら</a>
                </div>
                <button type="submit" disabled={isLoading}>
                  {isLoading ? 'Loading...' : 'ログイン'}
                </button>
                <div className={styles.registerLink}>
                  <a onClick={handlePreRegister}>新規登録がまだの方はこちら</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
